import { LEGAL } from "@/lib/legal";
import { LegalDocument } from "@/components/LegalDocument";

export default function LegalPage({ docKey }) {
  const doc = LEGAL[docKey];
  return (
    <div className="mx-auto max-w-4xl px-5 py-12 lg:px-8" data-testid={`legal-page-${docKey}`}>
      <h1 className="font-display text-3xl font-black tracking-tight text-navy sm:text-4xl">{doc.title}</h1>
      <div className="mt-3 h-1 w-16 rounded-full bg-brand" />
      <div className="mt-8">
        <LegalDocument docKey={docKey} />
      </div>
    </div>
  );
}
